import { useNavigate } from 'react-router-dom';

import { Box, Stack } from '@mui/material';

import { PATH_STANDARD } from 'src/routes/paths';

import useAuth from 'src/hooks/useAuth';
import useResponsive from 'src/hooks/useResponsive';

import { WorkflowDashboardRunDto } from 'src/@types/workflow/types';

import DashboardWorkflowRunSteps from './DashboardWorkflowRunSteps';
import { isWaitingOn, orderedRenderableSteps } from './dashboardRun';
import DashboardWorkflowRunStatus from './DashboardWorkflowRunStatus';
import DashboardWorkflowRunSummary from './DashboardWorkflowRunSummary';

type DashboardWorkflowStatusItemProps = {
  run: WorkflowDashboardRunDto;
};

export default function DashboardWorkflowStatusItem({ run }: DashboardWorkflowStatusItemProps) {
  const { user } = useAuth();
  const navigate = useNavigate();
  const isMobile = useResponsive('down', 'sm');

  const isWaitingOnMe = isWaitingOn(run, user?.email);

  return (
    <Box
      onClick={() => navigate(PATH_STANDARD.documentsId(run.documentId))}
      sx={{
        px: 2,
        py: 1.75,
        cursor: 'pointer',
        borderLeft: '3px solid',
        borderLeftColor: isWaitingOnMe ? 'warning.main' : 'transparent',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Stack
        spacing={1.5}
        direction={isMobile ? 'column' : 'row'}
        sx={{ alignItems: isMobile ? 'stretch' : 'center' }}
      >
        <DashboardWorkflowRunSummary run={run} isWaitingOnMe={isWaitingOnMe} />

        <Stack
          direction="row"
          spacing={1.5}
          sx={{ alignItems: 'center', justifyContent: isMobile ? 'space-between' : 'flex-end' }}
        >
          <DashboardWorkflowRunSteps steps={orderedRenderableSteps(run)} />

          <DashboardWorkflowRunStatus run={run} />
        </Stack>
      </Stack>
    </Box>
  );
}
